// Copyright (c) 2026 Otyka LLC. All rights reserved.

import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';

const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID || 'us-east-1_8St8Y7gCf';
const CLIENT_ID = process.env.REACT_APP_USER_POOL_CLIENT_ID || '49r0jvo0kcishf15p7ee2489p3';

const userPool = new CognitoUserPool({
  UserPoolId: USER_POOL_ID,
  ClientId: CLIENT_ID,
});

export function getCurrentUser() {
  return userPool.getCurrentUser();
}

export function getIdToken() {
  return new Promise((resolve, reject) => {
    const user = getCurrentUser();
    if (!user) return reject(new Error('Not logged in'));
    user.getSession((err, session) => {
      if (err) return reject(err);
      if (!session.isValid()) return reject(new Error('Session expired'));
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

export function login(email, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: userPool });
    const authDetails = new AuthenticationDetails({ Username: email, Password: password });

    user.authenticateUser(authDetails, {
      onSuccess: (session) => resolve({ session, user }),
      onFailure: (err) => reject(err),
      newPasswordRequired: (userAttributes) => {
        // First login with temp password — resolve with challenge info
        resolve({ newPasswordRequired: true, user, userAttributes });
      },
    });
  });
}

export function completeNewPassword(user, newPassword) {
  return new Promise((resolve, reject) => {
    user.completeNewPasswordChallenge(newPassword, {}, {
      onSuccess: (session) => resolve({ session }),
      onFailure: (err) => reject(err),
    });
  });
}

export function logout() {
  const user = getCurrentUser();
  if (user) user.signOut();
}

export function isLoggedIn() {
  return new Promise((resolve) => {
    const user = getCurrentUser();
    if (!user) return resolve(false);
    user.getSession((err, session) => {
      resolve(!err && session?.isValid());
    });
  });
}
